export const TAG_TYPES = {
    NEWS: 'News',
    CARDS: 'Cards',
    FACTIONS: 'Factions',
    DECKS: 'Decks',
    USER: 'User',
    SESSIONS: 'Sessions',
    BLOCKLIST: 'Blocklist',
    ADMIN: 'Admin',
    BANLIST: 'Banlist',
    GAMES: 'Games',
    LOBBY: 'Lobby',
    OIDC: 'Oidc',
    LOCATION: 'Location',
    // ARCHON (I3): optional player bio.
    BIO: 'Bio',
    // ARCHON (N12): profile cosmetics (accent, banner, frame, title, effect).
    COSMETICS: 'Cosmetics',
    TOURNAMENTS: 'Tournaments',
    FRIENDS: 'Friends',
    CLUBS: 'Clubs',
    STORES: 'Stores',
    RATINGS: 'Ratings',
    BUG_REPORTS: 'BugReports',
    NOTIFICATIONS: 'Notifications',
    // ARCHON: direct messages - the inbox, a thread, and the unread badge.
    MESSAGES: 'Messages',
    // ARCHON (N7): team rosters and the team ladder.
    TEAMS: 'Teams',
    // ARCHON (N13): in-person (paper) games.
    IN_PERSON_GAMES: 'InPersonGames',
    // ARCHON (N8): the admin operations dashboard.
    ANALYTICS: 'Analytics',
    // ARCHON (N5): reports, the moderation queue and the audit log.
    MODERATION: 'Moderation',
    // ARCHON (N12): Patreon link + pledge status.
    PATREON: 'Patreon',
    // ARCHON (N12): premium membership and entitlements.
    MEMBERSHIP: 'Membership',
    // ARCHON (N12): Archon Intelligence analytics.
    INTELLIGENCE: 'Intelligence',
    // ARCHON (N18): the Champion’s Challenge - simulated deck testing.
    CHAMPIONS_CHALLENGE: 'ChampionsChallenge'
};
